import axios from "axios";
import { StoreModel } from "../models";

// const host = 'http://54.90.219.85:4000/api'
const host = "http://localhost:4000/api";
// const host = 'http://backend.enlineate.com:4000/api'

export async function axiosGET(url: string, params?: any) {
  if (params === null) params = {};
  // console.log(host, url)
  const response = await axios.get(`${host}/${url}`, {
    params: params,
    headers: { "Content-Type": "application/json" },
  });
  return response;
}

export async function axiosPOST(url: string, body: any) {
  const response = await axios.post(`${host}/${url}`, {
    headers: { "Content-Type": "application/json; multipart/form-data" },
    data: body,
  });

  return response;
}

export async function axiosPUT(url: string, body: any){
  const response = await axios.put(url, body)

  return response;
}

export async function axiosAuthPOST(url: string, body: any, token: string) {
  // const response = await axios.post(`${host}/${url}`, body, {
  //   headers: {
  //     "Content-Type": "application/json; multipart/form-data",
  //     Authorization: `${token}`,
  //   },
  //   data: body,
  // });

    const response = await axios.post(`${host}/${url}`, {
    headers: {
      "Content-Type": "application/json; multipart/form-data",
      Authorization: `${token}`,
    },
    data: body,
  });

  return response;
}

export async function axiosAuthGET(url: string, token: string, params?: any) {
  if (params === null) params = {};
    const response = await axios.get(`${host}/${url}`, {
      params: params,
      headers: {
        "Content-Type": "application/json; multipart/form-data",
        Authorization: token,
      },
    });
  
    return response;
  }

export async function axiosFormDataPOST(url: string, body: any) {
  const response = await axios.post(`${host}/${url}`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response;
}
